module.exports = __webpack_public_path__ + "img/risorse2.605e98b4.png";